import * as React from "react";

const ReorderWarningIcon = ({
  brandingColor = "#DBAD06",
}: {
  brandingColor?: string;
}) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="m-1"
  >
    <path
      d="M9.75002 11.5497V6.14966M9.75 14.15H9.84999M10.8004 1.36978C10.6967 1.18202 10.5445 1.0255 10.3598 0.916498C10.1751 0.807489 9.96449 0.75 9.75001 0.75C9.53545 0.75 9.32489 0.807489 9.14016 0.916498C8.95544 1.0255 8.80328 1.18202 8.6996 1.36978L0.899479 15.7699C0.798612 15.9527 0.747133 16.1585 0.750123 16.3672C0.753114 16.5758 0.81047 16.7801 0.91653 16.9598C1.02259 17.1396 1.17368 17.2885 1.35491 17.392C1.53613 17.4955 1.7412 17.55 1.94989 17.55H17.5501C17.7587 17.55 17.9639 17.4955 18.1451 17.392C18.3263 17.2885 18.4774 17.1396 18.5835 16.9598C18.6895 16.7801 18.7468 16.5758 18.7499 16.3672C18.7528 16.1585 18.7013 15.9527 18.6005 15.7699L10.8004 1.36978Z"
      stroke={brandingColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReorderWarningIcon;
